var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Watch, PropertyConverters, Utils, CustomElementUtils, Logging, PCSS } from '@pacem/pacem-core';
import { PacemWidgetElement } from '../types';
//namespace Pacem.Components.Cms {
export class PacemUiWidgetElement extends PacemWidgetElement {
    constructor(metadata, colspan = 1, role) {
        super(metadata, role);
        this.colspan = colspan;
        this.rowspan = 1;
    }
    // just a flag class
    connectedCallback() {
        super.connectedCallback();
        Utils.addClass(this, 'ui-widget ' + PCSS + '-cell cols-xs-start-1 cols-xs-12 rows-xs-start-auto');
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'row':
                Utils.removeClass(this, `rows-start-${old + 1}`);
                Utils.addClass(this, `rows-start-${val + 1}`);
                break;
            case 'rowspan':
                Utils.removeClass(this, `rows-${old}`);
                Utils.addClass(this, `rows-${val}`);
                break;
            case 'column':
                Utils.removeClass(this, `cols-start-${old + 1}`);
                Utils.addClass(this, `cols-start-${val + 1}`);
                break;
            case 'colspan':
                Utils.removeClass(this, `cols-${old}`);
                Utils.addClass(this, `cols-${val}`);
                break;
            case 'borders':
                (this.borders ? Utils.addClass : Utils.removeClass).apply(this, [this, PCSS + '-border']);
                break;
            case 'corners':
                (this.borders ? Utils.addClass : Utils.removeClass).apply(this, [this, PCSS + '-corners']);
                break;
        }
    }
    get container() {
        return this._container;
    }
    /** @overridable */
    findContainer() {
        return CustomElementUtils.findAncestor(this, n => n instanceof PacemCompositeWidgetElement);
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        let iter = this._container = this.findContainer();
        if (!Utils.isNull(iter)) {
            iter.register(this);
        }
    }
    disconnectedCallback() {
        if (!Utils.isNull(this._container)) {
            this._container.unregister(this);
        }
        super.disconnectedCallback();
    }
}
__decorate([
    Watch({ emit: true, reflectBack: true, converter: PropertyConverters.Number })
], PacemUiWidgetElement.prototype, "column", void 0);
__decorate([
    Watch({ emit: true, reflectBack: true, converter: PropertyConverters.Number })
], PacemUiWidgetElement.prototype, "row", void 0);
__decorate([
    Watch({ emit: true, reflectBack: true, converter: PropertyConverters.Number })
], PacemUiWidgetElement.prototype, "colspan", void 0);
__decorate([
    Watch({ emit: true, reflectBack: true, converter: PropertyConverters.Number })
], PacemUiWidgetElement.prototype, "rowspan", void 0);
__decorate([
    Watch({ emit: true, reflectBack: true, converter: PropertyConverters.Boolean })
], PacemUiWidgetElement.prototype, "borders", void 0);
__decorate([
    Watch({ emit: true, reflectBack: true, converter: PropertyConverters.Boolean })
], PacemUiWidgetElement.prototype, "corners", void 0);
export const WidgetRegisterEventName = "widgetregister";
export const WidgetUnregisterEventName = "widgetunregister";
export const LayoutChangeEventName = "layoutchange";
export class WidgetRegisterEvent extends CustomEvent {
    constructor(item, eventInit) {
        super(WidgetRegisterEventName, Utils.extend(eventInit || {}, { detail: item }));
    }
}
export class WidgetUnregisterEvent extends CustomEvent {
    constructor(item, eventInit) {
        super(WidgetUnregisterEventName, Utils.extend(eventInit || {}, { detail: item }));
    }
}
export class PacemCompositeWidgetElement extends PacemUiWidgetElement {
    get itemsElement() {
        return this;
    }
    validate(item) {
        return item instanceof PacemUiWidgetElement;
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        Utils.addClass(this.itemsElement, PCSS + '-items-element');
    }
    /**
     * Appends a child Element to this CompositeWidget's itemsElement.
     * @param item New child element
     */
    appendItem(item) {
        this.itemsElement.appendChild(item);
    }
    /**
     * Registers a new item among the items.
     * @param item {PacemUiWidgetElement} Item to be enrolled
     */
    register(item) {
        if (!this.validate(item)) {
            this.log(Logging.LogLevel.Debug, `${(item && item.localName)} element couldn't be registered in a ${this.localName} element.`);
            return false;
        }
        let retval = false;
        const items = this.items = this.items || [];
        if (Utils.isNullOrEmpty(items)) {
            this.items = [item];
            retval = true;
        }
        else if (items.indexOf(item) === -1) {
            items.push(item);
            retval = true;
        }
        //
        if (retval) {
            this.dispatchEvent(new WidgetRegisterEvent(item));
        }
        return retval;
    }
    /**
     * Removes an existing element from the items.
     * @param item {PacemUiWidgetElement} Item to be removed
     */
    unregister(item) {
        const items = this.items, ndx = !Utils.isNullOrEmpty(items) && items.indexOf(item);
        if (ndx >= 0) {
            let item = items.splice(ndx, 1);
            this.dispatchEvent(new WidgetUnregisterEvent(item[0]));
            return true;
        }
        return false;
    }
}
__decorate([
    Watch( /* can only be databound or assigned at runtime */)
], PacemCompositeWidgetElement.prototype, "items", void 0);
//  #endregion COMPOSITE
